// Built-in TS/JS symbol outline, registered as an in-process outline provider.
// This is the first "built-in plugin": it uses the same OutlineRegistry a
// third-party plugin would, but runs trusted and in-process (it drives the
// existing tree-sitter worker client). Imported for its side effect.
import {
  outlineRegistry,
  outlineLanguageForFile,
  SUPPORTED_OUTLINE_EXTENSIONS,
  type OutlineProvider,
  type CodeSymbol,
} from '@slate/core';
import { extractSymbolsInWorker } from '../perf/symbolsClient';

const builtinTsJsOutline: OutlineProvider = {
  id: 'builtin.tsjs',
  extensions: [...SUPPORTED_OUTLINE_EXTENSIONS],
  getSymbols(source: string, fileName: string): Promise<CodeSymbol[]> {
    const lang = outlineLanguageForFile(fileName);
    if (!lang) return Promise.resolve([]);
    return extractSymbolsInWorker(source, lang);
  },
};

outlineRegistry.register(builtinTsJsOutline);
